export const DEFAULT_CONFIRM_STARTING_TEXT = 'Are you sure you want to ' as const;

export const DEFAULT_DELETE_RESOURCE_DETAILS_TEXT =
  'If patient/clinician data is affected by this change, you will see another confirmation alert with more details.' as const;
export const DEFAULT_FORCE_DELETE_RESOURCE_DETAILS_TEXT =
  'This action is irreversible, final and instant. Please consider the implications carefully.' as const;
